<script setup>

import SearchIconComponent from "@/components/common/button/searchAndResetButton.vue";
import TotalCount from "@/components/common/totalCount/totalCount.vue";
import MeetingInsert from "@/components/modal/meeting/meetingInsertModal.vue";
import AddButton from "@/components/common/button/addButton.vue";
import DeleteButton from "@/components/common/button/deleteButton.vue";
import {computed, onMounted, ref, toRef, watch} from "vue";
import axios from "@/axios";
import MeetingType from "@/components/common/input/meetingType.vue";
import DetailMeeting from "@/components/modal/meeting/detailMeeting.vue";
import PagingComponent from "@/components/common/paging/pagingComponent.vue";
import PagePerItems from "@/components/common/paging/pagePerItems.vue";
import {useComStore, useLanguageStore, useLoadingStore} from "@/pinia";
import {formatDate} from "@/plugins/dayjs";
import {useToast} from "@/composables/useToast";

const toast = useToast();
import AgeSelectBox from "@/components/common/input/ageSelectBox.vue";
import MeetingRoomSelectBox from "@/components/common/input/meetingRoomSelectBox.vue";
import {VDateInput} from "vuetify/lib/labs/VDateInput";
const loadingStore = useLoadingStore();
const languageStore = useLanguageStore();
const useComCode = useComStore();

const detailInfo = ref(null);
const title = computed(() => languageStore.get('meetingManagement'));
const totalCount = ref(0);
const currentPage = ref(1);
const pageSize = ref(20); // grid: 20, list: 10
const meetingLists = ref([]);
const selectMeeting = ref('');
const sortDirection = ref('ASC');
const sortValue = ref(["regDt"]);
const meetingRoom = ref();
const totalPage = ref(0);
const meetingType = ref();
const isInsertMeeting = ref(false);
const isDetailMeeting = ref(false);
const isReset = ref(false);
const viewMode = ref('grid'); // 'grid' | 'list'

// 뷰 모드에 따른 pageSize 변경
watch(viewMode, (newMode) => {
  const newSize = newMode === 'grid' ? 20 : 10;
  if (pageSize.value !== newSize) {
    currentPage.value = 1;
    pageSize.value = newSize;
    getData();
  }
});

const searchAge = ref();
const searchDate = ref();
const searchMeetingRoom = ref()

const formatSearchDate = (date, isEnd) => {
  if (!date) return null;
  const d = new Date(date);
  if (isEnd) {
    d.setHours(23, 59, 59, 999);
  } else {
    d.setHours(0, 0, 0, 0);
  }
  return d.toISOString();
}


const emits = defineEmits(['set_title'])


const today = useComCode.today;


const computedDate = (date)=> {
  return formatDate(date, 'YYYY-MM-DD');
}
const set_searchMeetingRoom= (v)=>{
  searchMeetingRoom.value = v;
}
const set_meetingRoom = (v)=>{
  meetingRoom.value = v;
}

const set_currentPage= (page)=>{
  currentPage.value = page
  getData();
}
const set_pageSize = (size)=>{
  currentPage.value= 1;
  pageSize.value= size;
  getData();
}
const set_isDetailMeeting= (is)=>{
  isDetailMeeting.value = is;
}
const selectedMeeting=(e)=>{
  selectMeeting.value = e;
}
const set_isInsertMeeting= (is)=>{
  isInsertMeeting.value = is;
}
const fn_modifyMeeting = (data) =>{
  loadingStore.set_isLoading(true);
  axios.put("/api/meeting", data, {headers: { 'Content-Type': 'application/json' }})
      .then(s=>{
        getData();
        loadingStore.set_isLoading(false);
      }).catch(e=>{
        loadingStore.set_isLoading(false);
        toast.error(languageStore.get('errorOccurred'));
      })
}
const youtubeLiveMeetingAdd = (data)=>{
  loadingStore.set_isLoading(true);
  axios.post("/api/liveRegist", data, {headers: { 'Content-Type': 'application/json' }})
      .then(s=>{
        getData();
        loadingStore.set_isLoading(false);
      })
      .catch(e=>{
        console.log(e)
        loadingStore.set_isLoading(false);
      })
}
const fn_saveMeeting = (data)=>{
  loadingStore.set_isLoading(true);

  axios.post("/api/meeting", data, {headers: { 'Content-Type': 'application/json' }})
      .then((s)=> {
        console.log(s);
        if(data.isYoutube){
          let newData = {
            meetingId : s.data,
            privateStatus : 'public',
            liveStartDt : data.meetingPreDt,
            liveTitle : computedDate(data.meetingPreDt)+"_"+ useComCode.getCommonNm(data.meetingType.codeId) + (data.committeeId != null ?"_"+useComCode.getCommonNm(data.committeeId.codeId) :"" ),
            liveDescription : data.memo
          }
          youtubeLiveMeetingAdd(newData);
          loadingStore.set_isLoading(false);
        }else{
          getData();
          loadingStore.set_isLoading(false);
        }
      })
      .catch(e=> {
        console.log(e);
      })
}
const deleteMeeting=()=>{
  let sMeeting = selectMeeting.value
  if(sMeeting == null || sMeeting === '') {
    toast.warning(languageStore.get('pleaseSelectMeeting'));
    return;
  }
  if(confirm(languageStore.get('deleteConfirm'))) {
    axios.delete(`/api/meeting/${sMeeting}`)
        .then((s)=>{
          toast.success(languageStore.get('deleteSuccess'));
          selectMeeting.value = '';
          getData();
        })
        .catch(e=>{
          console.log(e);
          toast.error(languageStore.get('deleteFailed'));
        })
  }
}
const getData = ()=>{
  const data = {
    ageId : searchAge.value ,
    meetingType : meetingType.value != 'mt000' ?meetingType.value : null,
    meetingLocation : searchMeetingRoom.value,
    searchStartDate : searchDate.value && searchDate.value.length > 0 ? formatSearchDate(searchDate.value[0], false) : null,
    searchEndDate : searchDate.value && searchDate.value.length > 0 ? formatSearchDate(searchDate.value[searchDate.value.length-1], true) : null,
    size : pageSize.value,
    page : currentPage.value-1,
    direction : sortDirection.value,
    properties : sortValue.value
  };

  axios.post("/api/meetings/search",data, {headers: { 'Content-Type': 'application/json' }})
      .then(s=>{
        console.log(s)
        totalPage.value = s.data.totalPages
        totalCount.value = s.data.totalElements
        meetingLists.value = s.data.content
      })
}
const set_search_age = (v)=>{
  searchAge.value = v;
}
const set_selectMeetingType = (s_meetingType)=>{
  meetingType.value = s_meetingType;
}
const fn_doubleClick =()=>{
  detailInfo.value = meetingLists.value.find(m => m.meetingId === selectMeeting.value)
  isDetailMeeting.value = true
}
const fn_openYoutube = (e)=>{
  const url = 'https://youtu.be/'+e;
  window.open(url);
}
const fn_youtubeCreate = (e)=>{
  loadingStore.set_isLoading(true);
  const data = {
    meetingId : e.meetingId,
    privateStatus : 'public',
    liveStartDt : e.meetingPreDt,
    liveTitle : computedDate(e.meetingPreDt)+"_"+ e.meetingType.codeNm + (e.committeeId != null ?"_"+e.committeeId.codeNm :"" ),
    liveDescription : e.memo
  }
  youtubeLiveMeetingAdd(data);
}
const resetData = ()=>{
  isReset.value= true;
  searchDate.value = [];
  searchAge.value = null;
  meetingType.value = null;
  searchMeetingRoom.value = null;
  getData()
  setTimeout(()=> isReset.value=false ,1000)
}

onMounted(()=>{
  getData();
  emits('set_title', title.value);
})
watch(title, (v) => emits('set_title', v))

</script>

<template>
  <v-snackbar v-model="toast.show.value" :color="toast.color.value" :timeout="toast.timeout.value" location="top">
    {{ toast.message.value }}
    <template v-slot:actions>
      <v-btn variant="text" @click="toast.close()">{{ languageStore.get('close') }}</v-btn>
    </template>
  </v-snackbar>
  <div class="searchArea">
    <age-select-box
        class="search-field"
        :isReset="isReset"
        :label="languageStore.get('number')"
        @set_age-id="set_search_age"
    ></age-select-box>
    <MeetingType
        class="search-field"
        :isReset="isReset"
        :label="languageStore.get('meetingType')"
        @set_meetingType="set_selectMeetingType"
        :data ="{'codeId' : 'mt000', 'codeNm' : languageStore.get('all') }"
    ></MeetingType>
    <meeting-room-select-box
        class="search-field"
        :isReset="isReset"
        :label="languageStore.get('location')"
        @set_meetingRoom="set_searchMeetingRoom"
    ></meeting-room-select-box>
    <v-date-input
        class="search-field"
        :label="languageStore.get('meetingDate')"
        variant="outlined"
        density="compact"
        hide-details
        multiple="range"
        v-model="searchDate"
    ></v-date-input>
    <search-icon-component
        @fn_search="getData"
        @fn_reset="resetData"
    ></search-icon-component>
  </div>
  <div class="mainContentArea">
    <div class="contentTopArea">
      <total-count :total-count="totalCount"></total-count>
      <div class="contentTopRight">
        <div class="view-toggle">
          <v-btn-toggle v-model="viewMode" mandatory density="compact" variant="outlined">
            <v-btn value="list" size="small">
              <v-icon>mdi-format-list-bulleted</v-icon>
            </v-btn>
            <v-btn value="grid" size="small">
              <v-icon>mdi-view-grid</v-icon>
            </v-btn>
          </v-btn-toggle>
        </div>
        <page-per-items
            :page-per-items="pageSize"
            @set_pageSize="set_pageSize"
        ></page-per-items>
        <div class="addDeleteButtonArea">
          <add-button divide="meeting" @click="set_isInsertMeeting(true)"></add-button>
          <delete-button @click="deleteMeeting"></delete-button>
        </div>
      </div>
    </div>
    <div class="contentData">
      <!-- 리스트 뷰 -->
      <template v-if="viewMode === 'list'">
        <div class="contentHead">
          <div class="meetingCode">No.</div>
          <div class="meetingData">{{ languageStore.get('meetingDate') }}</div>
          <div class="session">{{ languageStore.get('number') }}</div>
          <div class="meetingClassification">{{ languageStore.get('meetingType') }}</div>
          <div class="committee">{{ languageStore.get('committee') }}</div>
          <div class="meetingVenue">{{ languageStore.get('location') }}</div>
          <div class="meetingNote">{{ languageStore.get('note') }}</div>
          <div>Youtube</div>
        </div>
        <div class="contentBody" v-if="meetingLists.length > 0">
          <div
              v-for="(meeting, index) in meetingLists"
              :key="index"
              :class="{ 'selectedMeetingList': selectMeeting === meeting.meetingId, 'meetingList': selectMeeting !== meeting.meetingId }"
              @click="selectedMeeting(meeting.meetingId)"
              @dblclick="fn_doubleClick"
          >
            <div class="meetingCode">{{ ((currentPage - 1) * 10) + index + 1 }}</div>
            <div class="meetingData">{{ meeting.meetingPreDt != null ? formatDate(meeting.meetingPreDt, 'YYYY-MM-DD') : '-' }}</div>
            <div class="session">{{ meeting.age?.ageTitle || '-' }}</div>
            <div class="meetingClassification">{{ meeting.meetingType.codeNm }}</div>
            <div class="committee">{{ meeting.committeeId != null ? meeting.committeeId.codeNm : '-' }}</div>
            <div class="meetingVenue">{{ meeting.meetingLocation.codeNm }}</div>
            <div class="meetingNote" :title="meeting.memo">{{ meeting.memo || '-' }}</div>
            <div v-if="meeting.liveId != null && meeting.liveId != ''">
              <img src="@/assets/YouTube.png" class="ylogo" @click.stop="fn_openYoutube(meeting.liveId)" />
            </div>
            <div v-else-if="new Date(meeting.meetingPreDt) > today">
              <template v-if="!loadingStore.isLoading">
                <v-btn size="small" @click.stop="fn_youtubeCreate(meeting)">create</v-btn>
              </template>
              <template v-else>
                <v-progress-circular :size="24" color="dark-blue" indeterminate></v-progress-circular>
              </template>
            </div>
            <div v-else>-</div>
          </div>
        </div>
        <div v-else class="noData">
          <v-icon size="36" color="#B0BEC5">mdi-database-off-outline</v-icon>
          <p>{{ languageStore.get('noData') }}</p>
        </div>
      </template>

      <!-- 그리드(카드) 뷰 -->
      <template v-else>
        <div class="card-container" v-if="meetingLists.length > 0">
          <div
              v-for="(meeting, index) in meetingLists"
              :key="index"
              :class="['meeting-card', { 'meeting-card--selected': selectMeeting === meeting.meetingId }]"
              @click="selectedMeeting(meeting.meetingId)"
              @dblclick="fn_doubleClick"
          >
            <div class="card-header">
              <div class="card-header__left">
                <span class="card-badge">{{ meeting.meetingType.codeNm }}</span>
                <span class="card-title">{{ meeting.age?.ageTitle || '-' }}</span>
              </div>
              <div class="card-header__right">
                <div v-if="meeting.liveId != null && meeting.liveId != ''" class="youtube-badge youtube-badge--active" @click.stop="fn_openYoutube(meeting.liveId)">
                  <img src="@/assets/YouTube.png" class="ylogo" />
                </div>
                <div v-else-if="new Date(meeting.meetingPreDt) > today" class="youtube-badge">
                  <template v-if="!loadingStore.isLoading">
                    <v-btn size="x-small" variant="outlined" @click.stop="fn_youtubeCreate(meeting)">Create</v-btn>
                  </template>
                  <template v-else>
                    <v-progress-circular :size="20" color="primary" indeterminate></v-progress-circular>
                  </template>
                </div>
              </div>
            </div>
            <div class="card-body">
              <div class="card-info-row">
                <span class="card-info-label">{{ languageStore.get('meetingDate') }}</span>
                <span class="card-info-value">{{ meeting.meetingPreDt != null ? formatDate(meeting.meetingPreDt, 'YYYY-MM-DD') : '-' }}</span>
              </div>
              <div class="card-info-row">
                <span class="card-info-label">{{ languageStore.get('location') }}</span>
                <span class="card-info-value">{{ meeting.meetingLocation.codeNm }}</span>
              </div>
              <div class="card-info-row" v-if="meeting.committeeId">
                <span class="card-info-label">{{ languageStore.get('committee') }}</span>
                <span class="card-info-value">{{ meeting.committeeId.codeNm }}</span>
              </div>
              <div class="card-info-row" v-if="meeting.memo">
                <span class="card-info-label">{{ languageStore.get('note') }}</span>
                <span class="card-info-value card-info-value--memo" :title="meeting.memo">{{ meeting.memo }}</span>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="noData">
          <v-icon size="36" color="#B0BEC5">mdi-database-off-outline</v-icon>
          <p>{{ languageStore.get('noData') }}</p>
        </div>
      </template>
    </div>

  </div>
  <div class="pagingArea">
    <paging-component
        @set_currentPage="set_currentPage"
        :page="currentPage"
        :total-page=totalPage
    ></paging-component>
  </div>
  <meeting-insert
      :isInsertMeeting="isInsertMeeting"
      @set_isInsertMeeting="set_isInsertMeeting"
      @fn_saveMeeting="fn_saveMeeting"
  ></meeting-insert>
  <detail-meeting
      :isDetailMeeting="isDetailMeeting"
      :meeting = 'detailInfo'
      @set_isDetailMeeting="set_isDetailMeeting"
      @fn_modifyMeeting = "fn_modifyMeeting"
  ></detail-meeting>
</template>

<style scoped>
.contentTopRight {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
}

/* 뷰 전환 토글 */
.view-toggle {
  display: flex;
  align-items: center;
}

.mainContentArea {
  background: white;
  width: 70vw;
  height: 70vh;
  border-radius: 5px;
  overflow-y: auto;
  overflow-x: hidden;
}

.searchArea {
  background: white;
  position: relative;
  width: 70vw;
  height: 8vh;
  margin: 10px 0 10px 0;
  padding: 0 20px;
  border-radius: 30px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
}

.search-field {
  min-width: 150px;
  max-width: 200px;
}

.contentTopArea {
  display: flex;
  justify-content: space-between;
  height: 6vh;
  align-items: center;
  padding: 1px 10px 0px 10px;
}

.addDeleteButtonArea {
  display: flex;
  min-width: 10vw;
  justify-content: space-around;
}

.noData {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  color: #90A4AE;
  font-size: 14px;
  gap: 8px;
}

.ylogo {
  width: 24px;
  height: 24px;
  cursor: pointer;
}

/* 카드 컨테이너 */
.card-container {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap: 16px;
  padding: 16px;
}

/* 카드 기본 스타일 */
.meeting-card {
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  overflow: hidden;
}

.meeting-card:hover {
  border-color: #1976d2;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.meeting-card--selected {
  border-color: #1976d2;
  background: #e3f2fd;
  box-shadow: 0 4px 12px rgba(25, 118, 210, 0.2);
}

/* 카드 헤더 */
.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  background: #f5f5f5;
  border-bottom: 1px solid #e0e0e0;
}

.meeting-card--selected .card-header {
  background: #bbdefb;
}

.card-header__left {
  display: flex;
  align-items: center;
  gap: 10px;
}

.card-badge {
  display: inline-block;
  padding: 4px 10px;
  background: #052C65;
  color: white;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 600;
}

.card-title {
  font-size: 15px;
  font-weight: 600;
  color: #333;
}

.card-header__right {
  display: flex;
  align-items: center;
}

.youtube-badge {
  display: flex;
  align-items: center;
}

.youtube-badge--active {
  cursor: pointer;
}

.youtube-badge--active:hover .ylogo {
  transform: scale(1.1);
}

/* 카드 본문 */
.card-body {
  padding: 16px;
}

.card-info-row {
  display: flex;
  align-items: flex-start;
  margin-bottom: 10px;
}

.card-info-row:last-child {
  margin-bottom: 0;
}

.card-info-label {
  flex-shrink: 0;
  width: 90px;
  font-size: 13px;
  color: #757575;
  font-weight: 500;
}

.card-info-value {
  flex: 1;
  font-size: 14px;
  color: #333;
}

.card-info-value--memo {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 200px;
}

.contentData {
  min-height: calc(70vh - 6vh - 10px);
}

/* 리스트 뷰 스타일 */
.contentHead {
  display: grid;
  grid-template-columns: 3vw 10vw 5vw 8vw 6vw 13vw 20vw 5vw;
  background: #052C65;
  color: white;
  height: 4vh;
  align-items: center;
  font-weight: bold;
}

.contentHead div {
  display: flex;
  align-items: center;
  justify-content: center;
}

.selectedMeetingList {
  display: grid;
  grid-template-columns: 3vw 10vw 5vw 8vw 6vw 13vw 20vw 5vw;
  align-items: center;
  height: 6vh;
  border-bottom: 1px solid #C7C7C7;
  background: #E0F0FF;
  font-size: 14px;
}

.meetingList {
  display: grid;
  grid-template-columns: 3vw 10vw 5vw 8vw 6vw 13vw 20vw 5vw;
  align-items: center;
  height: 6vh;
  border-bottom: 1px solid #C7C7C7;
  cursor: pointer;
  font-size: 14px;
}

.meetingList:hover {
  background: #E0F0FF;
}

.meetingList div,
.selectedMeetingList div {
  display: flex;
  align-items: center;
  justify-content: center;
}

.contentBody .session,
.contentBody .meetingClassification,
.contentBody .committee,
.contentBody .meetingVenue,
.contentBody .meetingNote {
  justify-content: flex-start !important;
  padding-left: 8px;
}

.meetingNote {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>